<template>
  <div id="app">
    <Navbar />
    <router-view/>
  </div>
</template>
<script>
  import Navbar from './components/Navbar';

  export default {
    name: 'app',
    components: {
      Navbar,
    },
  }
</script>

<style lang="scss">
// https://codepen.io/burntcustard/pen/PwGgJz
// https://www.w3schools.com/howto/howto_js_full_page_tabs.asp
// https://www.w3schools.com/howto/howto_js_sidenav.asp
// https://www.w3schools.com/bootstrap5/bootstrap_flex.php
// https://codepen.io/adammacias/pen/dozPVQ

/* Remove user agent styling */
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	// margin: 0;
	// padding: 0;
	// border: 0;
	// font-size: 100%;
	// font: inherit;
	vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
html {
  height:100%;
  background-color: black;
}
// body {
//   line-height: 1;
//   margin: 0; /*reset default margin*/
//   background-color: black;
// }
ol {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
ul {
  list-style-position: outside;
}
/* *********************************** */
// Elements
div {
  h1 {
    margin-top: 10px;
  }
  .homeborder {
    padding-top: 10px;
    // padding-bottom: 10px;
    border: solid 2px #c42f24;
    border-radius: 10px;
    background-color: #080808;
  }
}
p {
  line-height: 1.3 !important;
}
table {
  // background-color: #000000;
  width: 100%;
  height: 100%;
  tr {
    td {
      padding-bottom: 0px;
      padding-left: 0px;
      padding-right: 0px;
      .inline {
        display: inline;
      }
    }
  }
}
/* *********************************** */
// Classes
.big-font {
  font-size: 29px;
}
.black-border {
  border-top: solid 1px #080808 !important;
  border-bottom: solid 1px #080808 !important;
  border-left: solid 1px #080808 !important;
}
.bold {
  font-weight: bold;
}
.button {
  background-color: #080808;
  float: none;
  border: none;
  border-radius: 15px;
  margin-bottom: 10px;
  color: white;
  padding: 15px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}
.center {
  text-align: center;
}
.centerImage {
  max-width: 50%;
  border-radius: 15px;
  margin-bottom: 20px;
}
.centerImage2 {
  border-radius: 15px;
  margin-bottom: 20px;
}
.creationTable {
  margin-left: auto;
  margin-right: auto;
  tr {
    td {
      background-color:#080808;
      border: 2px solid #2d2653;
    }
  }
}
h1 {
    display: block;
    font-size: 2em;
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
}
.container {
  line-height: 1.4;
}
.p-2 {
  line-height: 1.4;
}
.cursor {
  cursor: pointer;
}
.featsTable {
  tr {
    td {
      background-color:#080808;
      border: 2px solid #71ad40;
    }
  }
}
.flex-container {
  justify-content: space-around;
}
.grid-container {
  display: grid;
  gap: 20px;
}
.setting-grid-container {
  display: grid;
  row-gap: 0px;
  column-gap: 10px;
}
.inline {
  display: inline;
}
.left-align {
  // display: inline-block; 
  text-align: left;
}
.mechanicsTable {
  margin-left: auto;
  margin-right: auto;
  tr {
    td {
      background-color:#080808;
      border: 2px solid #5ab188;
      // padding-top: 10px;
      // padding-left: 10px !important;
      // padding-right: 10px !important;
    }
  }
}
.miniText {
  font-size: 12px !important;
}
.minierText {
  font-size: 8px !important;
}
.navbar {
  padding-bottom: 0px !important;
  
}
.pcTable {
  margin-left: auto;
  margin-right: auto;
  tr {
    td {
      background-color:#080808;
      border: 2px solid #2d2653;
      // padding-top: 5px;
      // padding-left: 10px !important;
      // padding-right: 10px !important;
      // padding-left: 10px;
      // padding-right: 10px;
    }
  }
}
.round {
  border-radius: 10px;
  display: inline-block;
  max-width: 400px;
}
.settingTable {
  border: 2px solid #4484b8;
  margin-left: auto;
  margin-right: auto;
  th:first-child, th:nth-child(2), td:first-child, td:nth-child(2), td:nth-child(3), td:nth-child(4) {
    border: 2px solid #4484b8;
  }
  td {
    // padding-top: 10px;
    // padding-bottom: 0px;
  }
}
.genericButton {
  border: 2px solid white;
}
.poisonsTable {
  border: 2px solid #4484b8;
  margin-left: auto;
  margin-right: auto;
  border: 2px solid #4484b8;
  tr {
    td {
      border: 2px solid #4484b8;
      // padding-top: 10px;
      // padding-bottom: 10px;
    }
  }
}
.sideMargins {
  margin-left: 5%;
  margin-right: 5%;
}
.spacing {
  margin-bottom: 10px;
}
.spellsTable {
  tr {
    td {
      background-color:#080808;
      border: 2px solid #365ba1;
      padding-top: 0px !important;
      padding-left: 0px !important;
      padding-right: 0px !important;
      div {
        padding-left: 10px !important;
      }
    }
  }
}
.top-padding {
  // padding-top: 10px;
}
.top-padding2 {
  padding-top: 20px;
  padding-right: 10px;
}
.top-padding3 {
  padding-top: 10px;
  padding-left: 5px;
  padding-bottom: 5px;
}
.test {
  padding-top: 20px;
  display: block;
}
.weaponsTable {
  border: 2px solid #9046ad;
  margin-left: auto;
  margin-right: auto;
  // table-layout: fixed;
  width: 100%;
  th:first-child, th:nth-child(2), td:first-child, td:nth-child(2), td:nth-child(3), td:nth-child(4), td:nth-child(5) {
    border: 2px solid #9046ad;
  }
}
/* *********************************** */
// IDs
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: lightgrey;
  background-color: black;
  height:100%;
  background-color: black;
}
#conditionsTable {
  border: 2px solid #e04f35;
  margin-left: auto;
  margin-right: auto;
  th:first-child, th:nth-child(2), td:first-child, td:nth-child(2) {
    border: 2px solid #e04f35;
  }
}
#match {
  margin-left: auto;
  margin-right: auto;
  padding: 4px;
  margin-top: 20px;
  border-radius: 10px;
  width: 200px;
  font-weight: bold;
}
#exhaustionTable {
  td {
    border: none;
  }
}
#Disadvantage, #d20 {
  width: 30%;
  margin-right: 5%
}
#Advantage {
  width: 30%;
}
#signin, #signup {
  margin-top: 20px;
  font-weight: bolder;
  background-color: #198754;
}
#Username, #passone, #passtwo {
  border: none;
  border-radius: 5px;
  padding: 4px;
  margin: 10px;
}
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
// Viewports
/* Extra Small */
@media screen and (max-width: 500px) {
  .poisonsTable {
    tr {
      td:first-child {
        max-width: 110px;
        word-wrap: break-word;
      }
      td:nth-child(2) {
        max-width: 105px;
        word-wrap: break-word;
      }
    }
  }
}
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* Small */
@media screen and (max-width: 768px) {
  .creationTable, .featsTable, .mechanicsTable, .pcTable, .settingTable, .spellsTable, .weaponsTable, .dmTable {
    width: 100%;
  }
  .diceContainer {
    width: 95%;
    margin-left: 2.5%;
    margin-right: 2.5%;
  }
  .noshow {
    display: none;
  }
  .grid-container {
    grid-template-columns: auto;
    column-gap: 0px;
  }
  .Introduction {
    grid-area: 1 / 4;
  }
  .EnemyBehavior {
    grid-area: 2 / 4;
  }
  .Weather {
    grid-area: 3 / 4;
  }
  .Terrain {
    grid-area: 4 / 4;
  }
  // .Principles {
  //   grid-area: 7 / 3 / span 3;
  // }
  .centerImage {
    max-width: 100%;
  }
  .centerImage2 {
    max-width: 100%;
  }
}
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
@media screen and (min-width: 768px) {
  #conditionsTable, #runesTable, .pcTable, .weaponsTable {
    width: 80%;
  }
  #encounterButton, #suppliesButton, 
  #potionsButton, #poisonsButton, 
  #weaponsButton, #dcButton, #flashingButton, #magicItemsButton {
    text-align: center;
  }
  // #expandAllMiscellaneous {
  //   margin-left: 10%;
  // }
  .poisonsTable {
    tr {
      td:first-child {
        max-width: 150px;
      }
    }
  }
  .centerImage {
    margin-left: 25%;
    margin-right: 25%;
  }
  .centerImage2 {
    margin-left: 25%;
    margin-right: 25%;
    width: 50%;
  }
  .navbar {
    padding-top: 0px !important;
  }
}
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
// Medium
@media screen and (min-width: 768px) and (max-width: 900px) {
  #encounterButton {
    grid-area: 1 / 1 / 1 / span 2;
  }
  // #suppliesButton {
  //   grid-area: 2 / 1;
  // }
  #potionsButton {
    grid-area: 2 / 1;
  }
  #poisonsButton {
    grid-area: 2 / 2;
  }
  #weaponsButton {
    grid-area: 3 / 1;
  }
  // #dcButton {
  //   grid-area: 4 / 1;
  // }
  #flashingButton {
    grid-area: 3 / 2;
  }
  .grid-container {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  .Introduction {
    grid-area: 1 / 1;
  }
  .EnemyBehavior {
    grid-area: 1 / 2;
  }
  .Loot {
    grid-area: 2 / 1;
  }
  .Terrain {
    grid-area: 2 / 2;
  }
  .Weather {
    grid-area: 3 / 1;
  }
  .Magic {
    grid-area: 3 / 2;
  }
  .Principles {
    grid-area: 4 / span 2;
  }
  .diceContainer {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
}
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
// Large
@media only screen and (min-width: 900px) {
  #encounterButton {
    grid-area: 1 / 1 / span 2 / 2;
  }
  .diceContainer {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }
  .grid-container {
    grid-template-areas: 'Introduction EnemyBehavior Loot'
                         'Terrain Weather Magic';
  //   grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  }
  // .setting-grid-container {
  //   grid-template-areas: '';
  //   grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  // }
  // .grid-container {
  //   grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  // }
  .Introduction {
    grid-area: 1 / 1;
  }
  // .Terrain {
  //   grid-area: 2 / 1;
  // }
  // .Weather {
  //   grid-area: 2 / 2;
  // }
  .Principles {
    grid-area: 3 / span 1;
  }
}
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
/* *********************************** */
// Extra Large
@media only screen and (min-width: 1199px) {
  div ul li {
    margin: 0px;
  }
  .hideScroller::-webkit-scrollbar {
    display: none;
  }
}
/* *********************************** */
// Scrollbars
// https://itnext.io/dark-and-light-scrollbar-at-runtime-with-vue-and-vuetify-3809076e547d
// https://stackoverflow.com/questions/42872002/in-vue-js-component-how-to-use-props-in-css
// https://vuejs.org/guide/components/props.html
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  border-radius: 15px;
}
::-webkit-scrollbar-track {
  background: black;
}
.hideScroller::-webkit-scrollbar {
  display: none;
}
/* *********************************** */
// Animations

</style>
